var path = '/_common/directives/ifastPanel/iFastHelp/iFastHelp.tpl.html';
var html = " <div ng-repeat=\"record in iFastHelpController.helpInfoLst | orderBy:'order':false | filter:{visible:true}\" class=\"help-section clearfix\"> <strong class=help-key>{{record.key}}</strong> <span class=help-value data-ng-bind-html=\"record.value | sceTrustAsHtml\"/> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastPanel/iFastHelp/iFastHelp.tpl.html
// module id = 780
// module chunks = 0 2